/**
 * The "run a diagnostic build" button plus its result table.
 *
 * Runs the geometry without saving, which is the quickest way to see why a set
 * of parameters is rejected — a lightbox will report its cavity area, chamber
 * count and joint clearance here even when the build fails.
 */
import React from 'react';
import { FlaskConical } from 'lucide-react';
import { ManifoldPocResultPanel } from '../ThiknessAndMoreEditor.jsx';

const ManifoldDiagnostics = ({ manifoldPoc = {} }) => (
    <div className="mt-2">
        <div className="flex justify-end">
            <button
                type="button"
                className="btn btn-xs btn-info shrink-0 gap-1"
                onClick={manifoldPoc.onRun}
                disabled={manifoldPoc.state?.loading || !manifoldPoc.onRun}
            >
                {manifoldPoc.state?.loading
                    ? <span className="loading loading-spinner loading-xs"/>
                    : <FlaskConical className="h-3.5 w-3.5"/>}
                Diagnóstico
            </button>
        </div>
        <ManifoldPocResultPanel state={manifoldPoc.state} onClose={manifoldPoc.onClose}/>
    </div>
);

export default ManifoldDiagnostics;
